$(function() {
	$window = $(window);
	$header = $('.site_container > header');
	$body = $('body');
	var headerLogo = $('#logo')
	var mobileLogo = $('#mobile-logo')
	var heroHeader = $('.hero-logo')

	var header = $('.site_container > header');
	var collapseTimeout = null;
	var viewportHeight = $window.height();

	var min_inner_height = false;
	var max_inner_height = false;

	var header_height = $body.hasClass('home') ? 80 : 140;
	var reduced_header_height = 95;
	var current_header_height = $header.height();


	function scrolled_header_height(){
		var scrollTop = $window.scrollTop();
		if (scrollTop > 0) {
			return reduced_header_height
		} else {
			return header_height
		}
	}

	// var debug = $('<div class="debug" />').appendTo('body');

	$window.scroll(function() {
		var scrollTop = $window.scrollTop();
		var win_inner_h = window.innerHeight;



		if (scrollTop > 0) {
			$header.addClass('scrolled');
			$body.addClass('scrolled');
			heroHeader.removeClass('fade-in');
			mobileLogo.addClass('fade-in');
			headerLogo.addClass('fade-in');
			if(current_header_height == reduced_header_height) {
				var menuItems = header.find('.expanded');
				menuItems.removeClass('expanded');
			}
		} else {
			$header.removeClass('scrolled');
			$body.removeClass('scrolled');
			heroHeader.addClass('fade-in');
			mobileLogo.removeClass('fade-in');
			headerLogo.removeClass('fade-in');
		}

		if (!window.is_mobile) {
			if (scrollTop > 0) {
				$header.css('height', reduced_header_height)
				$body.addClass('attach_booking reduced_height_header');
			} else {
				$header.css('height', header_height)
				$body.removeClass('attach_booking reduced_height_header');
			}
		}

	    if (is_mobile_safari()) {
	        if (min_inner_height === false || win_inner_h < min_inner_height) {
	            min_inner_height = win_inner_h;
	        }
	        if ((max_inner_height === false || win_inner_h > max_inner_height) && win_inner_h > min_inner_height) {
	            max_inner_height = win_inner_h;
	        }
	        if (max_inner_height !== false && max_inner_height == win_inner_h) {
	            $('body').addClass('UI_hidden');
	        } else {
	            $('body').removeClass('UI_hidden');
	        }
	    }
	});


	if (!window.is_mobile) {
		var mainMenuElement = $('#main_menu');
		var topLevelElements = mainMenuElement.find('nav > ul > li, nav > ul > span');
		var subMenu = $('.sub-menu-wrapper');
		if ($('#menu-main-menu').hasClass('is_blog')) {
			var blogLink = mainMenuElement.find('a:contains("Blog")');
			blogLink.parent('li').addClass('current-menu-ancestor');
		}


		subMenu.each((function() {
			var menuImage = $(this).find('.menu-item-image');
			var menuList = $(this).find('.menu-item-list');
			var ulImages = $('<ul class="contains-images"></ul>');
			var ulList = $('<ul class="contains-list"></ul>');

			if(menuImage.length > 0) {
				$(this).prepend(ulImages);
				menuImage.each((function() {
				}));
				var elementUL = $(this).find('.contains-images');
				elementUL.each((function() {
					var elementImages = $(this).siblings()
					elementImages.each((function() {
						if($(this).hasClass('menu-item-image')) {
							elementUL.append($(this))
						} 
					}));
				}));
			}  


			if(menuList.length > 0) {
				$(this).append(ulList);
				menuList.each((function() {
					if($(this).hasClass('menu-item-list')) {
						ulList.append($(this))
						} 
					
				}));

				ulList.each(function() {
					var span = $(this).children().find('span');
					span.each(function() {
						var text = $(this).text()

						if(text.length > 20) {
							$(this).css("white-space", "pre-wrap")
						}
					})
				})
				
			}  

		}));

		topLevelElements.click(function(e) {
			if ($(e.target).attr('href') == '#')
				return false;
		});

		function expandHeader(submenu) {
			clearTimeout(collapseTimeout);
			var submenu = $(submenu);
			var expandedHeight = submenu.data('expandedHeight');
			header.css('height', scrolled_header_height() + expandedHeight);
			header.addClass('expanded');
		}

		function collapseHeader(delay) {
			header.find('.expanded').removeClass('expanded');
			header.css('height', scrolled_header_height());
			clearTimeout(collapseTimeout);
			if (delay) {
				collapseTimeout = setTimeout(function() {
					header.removeClass('expanded');
				}, 500);
			} else {
				header.removeClass('expanded');
			}
		}

		header.on('mouseleave focusout', function() {
			if (!header.hasClass('calculated'))
				return;

			collapseHeader(true);
		});

		topLevelElements.on('mouseenter focusin', function() {
			if (!header.hasClass('calculated'))
				return;

			topLevelElements.removeClass('expanded');
			var subMenu = $(this).find('.sub-menu');
			$(this).addClass('expanded');
			if (subMenu.length) {
				expandHeader(subMenu);
			} else {
				collapseHeader(true);
			}
		});

		function initMainMenu() {
			setTimeout(function() {
				// Store the heights of the submenus
				var subMenus = mainMenuElement.find('.sub-menu');
				subMenus.each(function() {
					$(this).data('expandedHeight', $(this).outerHeight());
					// var rightEdge = $(this).outerWidth() + $(this).offset().left;
					// if (rightEdge > $(window).width()) {

					// 	$(this).css('margin-left', $(window).width() - rightEdge - 30);
					// }
				});
				header.addClass('calculated');

				// var mainMenu = mainMenuElement.accessibleMenu(null, {
				// 	menuItemSelector: 'a',
				// 	orientation: window.is_mobile ? 'vertical' : ['horizontal', 'vertical'],
				// 	onItemExpanded: function(item, parent) {
				// 		expandHeader(parent.element);
				// 	},
				// 	onItemCollapsed: function(item, parent) {
				// 		collapseHeader(false);
				// 	}
				// });
			}, 500);
		}

		// Set timeout attempt to fix intermittent rendering bug
		$(window).on('fontsLoaded', function() {
			initMainMenu();
		});

	} else {
		var mainMenuElement = $('#mobile_menu');
		var topLevelElements = mainMenuElement.find('nav > ul > li, nav > ul > span');

		var toggle = $('#main_menu_toggle');
		toggle.click(function() {
			$body.toggleClass('menu_open');
			if ($body.hasClass('menu_open')) {
				toggle.toggleClass('open');
			} else {
				toggle.toggleClass('open');
				setTimeout(function() {
					topLevelElements.removeClass('expanded').removeClass('faded');;
				}, 100);
			}
		});

		$('.language_menu > nav > ul > li > a').click(function(){
			$('.language_menu').toggleClass('language_expanded');
		});

		topLevelElements.click(function(e) {
			clicked = $(this);

			var collapse = false;
			if (clicked.hasClass('current-menu-ancestor') && !clicked.parents('.language_menu').length)
				collapse = true;

			topLevelElements.removeClass('current-menu-ancestor');
			if ($(this).hasClass('menu-item-has-children')) {
				if ($(this).hasClass('expanded') || collapse) {
					topLevelElements.removeClass('faded');
					$(this).removeClass('expanded');
				} else {
					topLevelElements.removeClass('faded');
					clicked.siblings().addClass('faded');
					topLevelElements.removeClass('expanded');
					$(this).addClass('expanded');
					return false;
				}
			}
		});

		// Fix double tap requirement for main menu on iphone
		mainMenuElement.on('click touchend', function(e) {
			var el = $(this);
			var link = el.attr("href");
			if (link && link != '#')
				window.location = link;
		});

		// Add the scrolled class immediately on touch to avoid the delay on ios scrolling
		var initialTouchY = null;
		$('body').bind('touchstart', function(e) {
			var target = $(e.target);
			if (target.is('#main_menu_toggle') || target.parents('#main_menu_toggle').length)
				return;
			initialTouchY = e.originalEvent.touches[0].screenY;
		}).bind('touchmove', function(e) {
			newTouchY = e.originalEvent.touches[0].screenY;
			if (Math.abs(initialTouchY - newTouchY) > 10)
				$('header').addClass('scrolled');
		}).bind('touchend', function(e) {
			if ($window.scrollTop() == 0)
				$('header').removeClass('scrolled');
			initialTouchY = null;
		});
	}
});